import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { urlEndPoint } from 'src/app/common';
import { Message } from 'src/app/models/message';
import { ResponseTematic } from 'src/app/models/obs/apiResponse';
import { Networks } from 'src/app/models/obs/networks';
import { Tematic } from 'src/app/models/obs/tematic';
import { NetworkService } from 'src/app/services/obs/network.service';
import { TematicService } from 'src/app/services/obs/tematic.service';
import { ErrorHandlingService } from 'src/app/services/util/error-handling.service';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';

@Component({
  selector: 'app-admnetworks-form',
  templateUrl: './admnetworks-form.component.html',
  styleUrl: './admnetworks-form.component.scss'
})
export class AdmnetworksFormComponent implements OnInit {

  form: FormGroup;
  network: Networks = null;
  msg: Message;
  temdata: Tematic[];

  edit: boolean = false;
  URL: string = urlEndPoint;
  isUploadDir: boolean = false;
  filename: string = null;
  uploatedFile: File;

  typeOptions = [
    { title: 'Redes de Observatorios' },
    { title: 'Redes de Prospectiva' }
  ];

  constructor(
    private tematicsService: TematicService,
    private networkS: NetworkService,
    private uploadS: UploadfileService,
    private router: Router,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private errorService: ErrorHandlingService,

  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.createForm();
    this.getTematics();
    this.getnetwork(params);
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      name: ['', Validators.required],
      description: ['', Validators.required],
      url: ['', Validators.required],
      urlimage: ['', Validators.required],
      idtematic: [null, Validators.required],
      type: [null, Validators.required],
      status: [true],
    })
  }

  getnetwork(params: any) {
    if (params.id) {
      this.networkS.getOne(params.id).subscribe({
        next: res => {
          this.network = res['data'];
          this.verifiedImgDirectory();
          this.edit = true;
          this.loadData();
        },
        error: err => console.error(err)
      });
    } else {
      this.edit = false;
    }
  }

  getTematics() {
    this.tematicsService.getAll().subscribe({
      next: async ({ data }: any) => { this.temdata = data; },
      error: err => { this.msg = this.errorService.handleError(err); }
    });
  }

  verifiedImgDirectory() {
    if (this.network.urlimage != null) {
      (this.network.urlimage.substring(1, 7) === 'upload') ? this.isUploadDir = true : this.isUploadDir = false;
    }
  }

  onFileChange(e) {
    this.uploatedFile = e.target.files;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.form.get('urlimage').setValue(e.target['result']);
    };
    reader.readAsDataURL(this.uploatedFile[0]);
  }

  onUpload() {
    let formData = new FormData();
    formData.append("uploads", this.uploatedFile[0], this.uploatedFile[0].name);
    this.uploadS.uploadFileIMGR(formData).subscribe((res) => {
      this.filename = res['filename'];
      this.saveOrUpdate();
    });
  }

  save() {
    if (this.form.invalid) {
      console.log("Formulario inválido");
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      (this.uploatedFile != null) ? this.onUpload() : this.saveOrUpdate();
    }
  }

  saveOrUpdate() {
    this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
    this.router.navigate(['/adm/redes/list']);
  }

  create(network: Networks) {
    delete network.id;
    if (this.filename) { network.urlimage = '/uploads/redes/' + this.filename; }
    this.networkS.create(network).subscribe({
      next: res => {
        console.log("Se guardo");
      },
      error: err => { console.error(err) }
    });
  }

  update(id: string, network: Networks) {
    delete network.id;
    if (this.filename) { network.urlimage = '/uploads/redes/' + this.filename; }
    this.networkS.update(id, network).subscribe({
      next: res => {
        console.log("Se actualizo");
      },
      error: err => { console.error(err) }
    });
  }

  loadData() {
    this.form.reset(this.network);
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }

  cancel() {
    this.router.navigate(['/adm/redes/list']);
  }

}
